// extracted by mini-css-extract-plugin
module.exports = {"fieldset_footer":"fieldset-footer_fieldset_footer__qgT8K"};